<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('RSR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["SMB"]["RSR"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["BN"]}} :</span>
                                <customtreeselect :multiple="true"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="dd_agentgroup"
                                            :defaultExpandLevel="Infinity"
                                            v-model="searchAgi"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="str_FV[4].FV"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="getLanguage['MTA']['C']"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <label class="searchLabel"> {{this.getLanguage["RSR"]["RSN"]}} :</label>
                                <CInput vertical
                                        type="text"
                                        size="sm"
                                        :value="str_FV[3].FV" @change="v => str_FV[3].FV = v" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["SMB"]["RSRL"]}}</strong>
                    <div class="pageBtn">
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                    </div>
                </header>
                <div class="custom-table-wrapper" id="registerSourceReport">
                    <table class='custom-table afb-blue' v-if="showHourlyReport">
                        <thead>
                            <tr>
                                <th rowspan="2" style="width:15px" class="reg-list-font-size">{{this.getLanguage[["GL"]]["NO"]}}</th>
                                <th rowspan="2" style="width:80px" class="reg-list-font-size tableCtnCenter">{{this.getLanguage[["RSR"]]["SOR"]}}</th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["NOR"]}}</th>
                                <th rowspan="2" style="width:50px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MD"]}}</th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MDMTO"]}}</th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MDWB"]}}</th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["CR"]}}</th>
                                <th id="nestedTable" class="tableCtnCenter" colspan="100%" style=" border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-top-right-radius: 5px;">{{this.getLanguage[["RSR"]]["RCTH"]}} ({{this.str_FV[2].FV.startDate | moment('DD MMM YYYY')}} ~ {{this.str_FV[2].FV.endDate | moment('DD MMM YYYY')}})</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">00</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">01</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">02</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">03</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">04</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">05</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">06</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">07</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">08</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">09</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">10</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">11</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">12</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">13</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">14</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">15</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">16</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">17</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">18</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">19</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">20</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">21</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">22</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171); border-bottom-right-radius: 5px;">23</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="arry_rsrl.length == 0">
                                <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                            </tr>
                            <tr v-for="(data,index) in arry_rsrl">
                                <td class="reg-list-font-size">{{ CountItem(index+1) }}</td>
                                <td class="tableCtnCenter reg-list-font-size">{{ data.RSN }}</td>
                                <td class="reg-list-font-size">{{ formatNumber(data.NOR, 0) }}</td>
                                <td class="reg-list-font-size">{{data.DC}}</td>
                                <td class="reg-list-font-size">{{data.DMTO}}</td>
                                <td class="reg-list-font-size">{{data.DWP}}</td>
                                <td class="reg-list-font-size">{{ formatNumber(countConversionRate(data.DC,data.NOR), 0) }}%</td>
                                <td v-for="time in data.BH" class="reg-list-font-size">{{time}}</td>

                            </tr>
                        </tbody>
                    </table>
                    <table class='custom-table afb-blue' v-if="showDailyReport">
                        <thead>
                            <tr>
                                <th rowspan="2" style="width:15px" class="reg-list-font-size">{{this.getLanguage[["GL"]]["NO"]}}</th>
                                <th rowspan="2" style="width:80px" class="reg-list-font-size tableCtnCenter">{{this.getLanguage[["RSR"]]["SOR"]}}</th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["NOR"]}}</th>
                                <th rowspan="2" style="width:50px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MD"]}}</th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MDMTO"]}}</th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["MDWB"]}}</th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">{{this.getLanguage[["RSR"]]["CR"]}}</th>
                                <th id="nestedTable" class="tableCtnCenter" colspan="100%" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-top-right-radius: 5px;">{{this.getLanguage[["RSR"]]["RCBD"]}} ({{this.str_FV[2].FV.startDate | moment('DD MMM YYYY')}} ~ {{this.str_FV[2].FV.endDate | moment('DD MMM YYYY')}})</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD1"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD2"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD3"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD4"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD5"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage[["GL"]]["SWD6"]}}</th>
                                <th id="nestedTableR2" class="reg-list-font-size" style="border-left: 1.5px solid rgb(157, 157, 171);border-bottom-right-radius:5px;">{{this.getLanguage[["GL"]]["SWD7"]}}</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="arry_rsdl.length == 0">
                                <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                            </tr>
                            <tr v-for="(data,index) in arry_rsdl">
                                <td class="reg-list-font-size">{{ CountItem(index+1) }}</td>
                                <td class="tableCtnCenter reg-list-font-size">{{ data.RSN }}</td>
                                <td class="reg-list-font-size">{{ formatNumber(data.NOR, 0) }}</td>
                                <td class="reg-list-font-size">{{data.DC}}</td>
                                <td class="reg-list-font-size">{{data.DMTO}}</td>
                                <td class="reg-list-font-size">{{data.DWP}}</td>
                                <td class="reg-list-font-size">{{ formatNumber(countConversionRate(data.DC,data.NOR), 0) }}%</td>
                                <td v-for="time in data.BD" class="reg-list-font-size">{{time}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'

    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                str_tableSortBy: "RD", //(sort the table col name)
                bool_isSort: false,
                bool_showSearchBar: true,
                str_FV: [
                    { F: "AGI" },
                    { F: "CI" },
                    {
                        F: "CTS",
                        FV: {
                            startDate: this.getMonthStartDate(),
                            endDate: this.getMonthEndDate()
                        }
                    },
                    { F: "RSN" },
                    { F: "SAGAGI" }
                ], //Filter Value
                showHourlyReport: true,
                showDailyReport: true,
                arry_rsrl: [], //hourly RS report list
                arry_rsdl: [],
                dd_currency: [],
                dd_agentgroup: [],//agent group option,
                dd_subagentgroup: [],//subagent group option,
                ddDefaultSubBrand: [],
                rtSubBrand: 0,
                searchCurrency: null,
                constAccessType: constAccessType,
                hideBrand: false,
                searchAgi: null,
            }
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS4';
            this.$parent.showActiveMenu = 'R.RSR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.str_FV[3].FV = this.$route.query.rsn;

            if (this.$route.query.df) {
                this.str_FV[2].FV.startDate = this.$route.query.df;
                this.showHourlyReport = true;
                this.showDailyReport = false;
            }
            if (this.$route.query.dt) {
                this.str_FV[2].FV.endDate = this.$route.query.dt;
                this.showHourlyReport = true;
                this.showDailyReport = false;
            }
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
            this.getAgentGroup();
            this.getCurrencyList();

            if (this.$route.query.agi !== undefined && this.$route.query.agi !== null) {
                this.searchAgi = [];
                this.searchAgi.push(this.$route.query.agi);

                this.AgentGroupChangefs(this.searchAgi);
            }

            this.str_FV[1].FV = this.$route.query.ci;

            if (this.$route.path != this.$route.fullPath)
                this.getRsgisterSourceHourlyReportList();
                this.getRsgisterSourceDailyReportList();

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[1].FV.endDate = "";
                    }
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            //if (that.dd_agentgroup.length > 0) {
                            //    that.dd_agentgroup.forEach(that.disableAgentGroupParent);

                            //    if (that.dd_agentgroup[0].children == undefined) {
                            //        var at = 0;
                            //        at = that.dd_agentgroup[0].id.split("-")[0];
                            //        if (at == 3 && that.dd_agentgroup.length < 2) {
                            //            that.str_FV[0].FV = that.dd_agentgroup[0].id;
                            //        }
                            //    }
                            //}
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                this.str_FV[0].FV = null;
                this.str_FV[4].FV = null;
                if (value != undefined) {
                    //var agi = 0;
                    if (value != "") {
                        //agi = value.split("-")[1];
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.str_FV[0].FV = temp;
                        this.searchPAgi = this.str_FV[0].FV;
                        this.str_FV[4].FV = null;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[1].FV = null;
                this.dd_currency = null;
                this.getCurrencyList();
                //else {
                //    this.str_FV[0].FV = null;
                //    this.str_FV[4].FV = null;
                //}
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.str_FV[2].FV) {
                    if (this.str_FV[2].FV.startDate != "") {
                        var z = this.set90daysDateSearch(this.str_FV[2].FV.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }

                var cts_from = moment(String(this.str_FV[2].FV.startDate)).format('YYYYMMDD');
                var cts_to = moment(String(this.str_FV[2].FV.endDate)).format('YYYYMMDD');

                if (cts_from == cts_to) {
                    this.showHourlyReport = true;
                    this.showDailyReport = false;
                    this.getRsgisterSourceHourlyReportList();
                }
                else {
                    this.showHourlyReport = true;
                    this.showDailyReport = true;
                    this.getRsgisterSourceHourlyReportList();

                    this.getRsgisterSourceDailyReportList();
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.str_FV[0].FV) {
                    parentAGI = this.str_FV[0].FV;
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.str_FV[4].FV = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getRsgisterSourceHourlyReportList();
                        that.getRsgisterSourceDailyReportList();
                    });
            },
            getRsgisterSourceHourlyReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                path += "&f[ID]=2";
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 4) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {

                                var cts_from = moment(String(this.str_FV[i].FV.startDate)).format('YYYYMMDD');
                                path += "f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = moment(String(this.str_FV[i].FV.endDate)).format('YYYYMMDD');
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        //else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                        //    var agi = 0;
                        //    var value = this.str_FV[i].FV;
                        //    if (value != "") {
                        //        agi = value.split("-")[1];
                        //    }
                        //    path += "&f[AGI]=" + agi;

                        //}
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[4].FV) {
                    path += "&f[AGI]=" + this.str_FV[4].FV;
                }
                if (this.str_FV[0].FV) {
                    path += "&f[AGI_csv]=" + this.str_FV[0].FV;
                }

                this.getDataApi(`/api/rs/rsrhl?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setRegisterSourceReportList(d);
                        }
                    });
            },
            getRsgisterSourceDailyReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                path += "&f[ID]=1";
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 4) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {

                                var cts_from = moment(String(this.str_FV[i].FV.startDate)).format('YYYYMMDD');
                                path += "f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = moment(String(this.str_FV[i].FV.endDate)).format('YYYYMMDD');
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        //else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                        //    var agi = 0;
                        //    var value = this.str_FV[i].FV;
                        //    if (value != "") {
                        //        agi = value.split("-")[1];
                        //    }
                        //    path += "&f[AGI]=" + agi;

                        //}
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[4].FV) {
                    path += "&f[AGI]=" + this.str_FV[4].FV;
                }
                if (this.str_FV[0].FV) {
                    path += "&f[AGI_csv]=" + this.str_FV[0].FV;
                }

                this.getDataApi(`/api/rs/rsrdl?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setRegisterSourcedailyReportList(d);
                        }
                    });
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 4) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {

                                var cts_from = moment(String(this.str_FV[i].FV.startDate)).format('YYYYMMDD');
                                path += "f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = moment(String(this.str_FV[i].FV.endDate)).format('YYYYMMDD');
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        //else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                        //    var agi = 0;
                        //    var value = this.str_FV[i].FV;
                        //    if (value != "") {
                        //        agi = value.split("-")[1];
                        //    }
                        //    path += "&f[AGI]=" + agi;

                        //}
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[4].FV) {
                    path += "&f[AGI]=" + this.str_FV[4].FV;
                }
                if (this.str_FV[0].FV) {
                    path += "&f[AGI_csv]=" + this.str_FV[0].FV;
                }

                window.open('/api/rs/registersourceexcel?' + path, '_blank');
            },
            setRegisterSourcedailyReportList(data) {
                this.arry_rsdl = data;
            },
            setRegisterSourceReportList(data) {
                this.arry_rsrl = data;
            },
            countConversionRate(dc, nor) {
                var result = 0;
                if (nor != 0) {
                    result = (dc / nor) * 100;
                }
                return result;
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending
                this.getRsgisterSourceHourlyReportList();
                this.getRsgisterSourceDailyReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            formatDateWithDay(date) {
                var day = moment(date).format('dddd');
                var formatteddate = moment(date).format('ll');
                return day + ', ' + formatteddate;
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: this.getMonthStartDate(),
                    endDate: this.getMonthEndDate()
                };
            }
        },
        watch: {
            getLanguage() {
                this.getRsgisterSourceHourlyReportList();
                this.getRsgisterSourceDailyReportList();
            },
        },

    }

</script>

<style>
    #registerSourceReport table tr td, #registerSourceReport table tr th{
        text-align:right;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/RegisterSourceReport.vue